import Model from '../models/model';
import connectionService from '../services/Connection.js';

const model = new Model({
	name: 'EquipmentType',
	defaultSort: 'SortOrder',
	orderable: true,
	disableAdd: true,
	disableDelete: true,
	formTitleField: 'Name',
	gridTitle: 'EquipmentType',
	showGridRefreshBtn: true,
	columns: [
		{ header: 'UniqueId', field: 'EquipmentTypeId', width: 250, hidden: true },
		{ header: 'EquipmentType', field: 'Name', width: 190, required: true, readOnly: true },
		{ header: 'SortOrder', field: 'SortOrder', width: 190, type: 'number', required: true, readOnly: true },
		{ header: 'HasDisplay', field: 'IsWellDisplay', type: 'bool', width: 105, disabled: true },
		{
			header: 'Image',
			field: 'EquipmentTypeImage',
			type: 'file',
			width: 90,
			excludeOnGrid: true,
			hideFileName: true,
			accept: 'image/png',
			fileLocation: connectionService.PTXImage
		}
	]
});

export { model as equipmentTypeModel };

export default model.createFormBase();